export default __webpack_public_path__ + "static/media/icon_klaytn.207e75af.png";